import clsx from "clsx";

interface Props {
  color?: "primary" | "gray";
  type?: "submit" | "button";
  children: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

const LoginButton = ({
  type = "button",
  color = "primary",
  children,
  onClick,
  className,
  disabled,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={clsx(
        "inline-flex items-center justify-center rounded-md h-12 font-bold text-16 duration-300 disabled:cursor-not-allowed",
        {
          "bg-primary text-white": color === "primary",
          "bg-gray text-secondary": color === "gray",
        },
        className,
      )}
    >
      {children}
    </button>
  );
};

export default LoginButton;
